export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9135.2bf248b7.jpg";